module.exports = __webpack_public_path__ + "card_view.02a33101.png";